import { Component, OnInit, inject } from '@angular/core';
import { EmailtemplateService } from '../../service/settings/emailtemplate.service';
import { NotificationService } from '../../service/common/notification/notification.service';
import { EmailTemplate } from '../../domain/model/emailtemplate';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'tnb-settings-emailtemplates',
    templateUrl: './settings-emailtemplates-page.component.html',
    styleUrls: [
        './settings-emailtemplates-page.component.scss',
    ],
    standalone: false,
})
export class SettingsEmailtemplatesPageComponent implements OnInit {
    private emailTemplateService = inject(EmailtemplateService);
    private notificationService = inject(NotificationService);

    public emailTemplates$: Observable<EmailTemplate[]>;

    ngOnInit(): void {
        this.emailTemplates$ = this.emailTemplateService.getEmailTemplates();
    }

    saveAllEmailTemplates(emailTemplates: EmailTemplate[]): void {
        this.emailTemplateService.saveAllEmailTemplates(emailTemplates)
            .pipe(take(1))
            .subscribe(() => this.notificationService.success('Die E-Mail-Templates wurden erfolgreich gespeichert'));
    }

    getHeadlineFor(emailType: string): string {
        if (emailType === 'DATA_CONFIRMATION_OVERDUE') {
            return 'Erinnerungs-E-Mail zur Aktualisierung/Kontrolle der Erzeuger';
        }
        if (emailType === 'DATENABFRAGE_OVERDUE') {
            return 'Erinnerungs-E-Mail zu nicht ausgefüllten Datenabfragen';
        }
        if (emailType === 'CONTACT_DATA_UPDATE') {
            return 'Warnungs-E-Mail bei Aktualisierung der Kontaktdaten';
        }
        return '';
    }

    public sendTestEmails() {
        this.emailTemplateService.sendTestEmail()
            .pipe(take(1))
            .subscribe(() => this.notificationService.success('Die Test-E-Mails werden alsbald verschickt.'));
    }
}
